import React from 'react';
import { Container } from 'react-bootstrap';
import cross from '../../assets/images/cross.png';

const EmailVerifyFailed = () => {
  return (
    <div className='app-container mobile-bottom'>
      <Container className='mb-4 text-center mt-5'>
        {/* Faild condition */}
        <img src={cross} className='' alt='cross' width={60} />
        <h5 className='mt-3 mb-3'>Email Verified Failed/Expired.</h5>
        <p className='mb-0'>Your email address could not be verified.</p>
        <p>Please resend and verify again.</p>
      </Container>
    </div >
  );
};

export default EmailVerifyFailed;